import http from "@mono/network";

const getUserInfoByUid = async (uid) => {
  return await http.get(`/user/getUserInfoByUid/${uid}`);
};

/**
 * 获取当前轮数据，用来恢复游戏
 * @returns {"code":0,"data":{"betFoods":[{"betAmount":0,"betFoodId":0}],"currRoundLeftTime":0,"currRoundNum":0,"foodInfoList":[{"id":0,"name":"string","odds":0}],"latestResults":[0],"myCoins":0,"todayEarnings":0},"message":"string","sucessed":true}
 */
const getData = async () => {
  return await http.get("/lottery/getUserLotteryInfo");
};

/**
 * 下注
 * @param {foodId: 1, coinsNum:10, roundNum: 1}
 * @returns {code: 200, message: ""}
 */
const betting = async (data) => {
  return await http.post("/lottery/betting", data);
};

/**
 * 获取当前轮结果
 * @returns {"code":0,"data":{"betAmount":0,"drawAmount":0,"drawFoodId":0,"drawFoodName":"string","roundNum":0,"winners":[{"avatar":"string","drawAmount":0,"name":"string","uid":0}]},"message":"string","sucessed":true}
 */
const getLotteryResult = async () => {
  return await http.get("/lottery/getCurrLotteryResult");
};

/**
 * 获取游戏历史记录
 * @returns
 */
const getLotteryHistoryList = async (currPage, pageSize) => {
  return await http.get("/lottery/getUserLotteryHistoryList", {
    params: {
      currentPage: currPage,
      pageSize: pageSize,
    },
  });
};

/**
 * 获取游戏记录详情
 * @param {*} lotteryId 游戏记录id
 * @returns
 */
const getLotteryHistoryDetail = async (lotteryId) => {
  return await http.get("/lottery/getUserLotteryHistoryDetail", {
    params: {
      lotteryId: lotteryId,
    },
  });
};

export default {
  getUserInfoByUid,
  getData,
  betting,
  getLotteryResult,
  getLotteryHistoryList,
  getLotteryHistoryDetail,
};
